module.exports = __webpack_public_path__ + "img/1f234c1b67546cf844afcaf0257c5080.eot";